import React from 'react'
import { Paper, Grid, IconButton } from "@material-ui/core"
import { CustomField } from "../../../../../shared/components/formFields"
import AddInputField from "../AddInputField"
import MoreOptions from "../BuilderComponents/MoreOptions"

function Presentation({ fields, section, sectionKey, dummyData, setData }) {
  return (
    <Grid item xs={12}>
      <div className="d-flex justify-content-between" >
        <div>
          <h3 className="">
            <u>{section.sectionName}:</u>
          </h3>
        </div>
        <div>
          <AddInputField sectionKey={sectionKey} section={section} />
        </div>
      </div>

      <Grid container spacing={1}>
        {
          fields.map(field => {
            const {
              type,
              required,
              label,
              values = [],
              name,
              minDate = null,
              maxDate = null,
              country = ""
            } = field
            return type !== "" ?
              <Grid item xs={4}>
                <div className="d-flex" >
                  <CustomField
                    type={type}
                    required={required}
                    label={label}
                    menuItems={values}
                    handleChange={(e) => setData({ [name]: e.target.value })}
                    value={dummyData[name]}
                    minDate={dummyData[minDate]}
                    maxDate={type === "todate" ? dummyData[maxDate] : undefined}
                    country={dummyData[country]}
                  />
                  <span className="opt-suffix" >
                    <MoreOptions
                      sectionKey={sectionKey}
                      fieldName={name}
                      section={section}
                      field={field}
                    />
                  </span>
                </div>
              </Grid>
              :
              <Grid item xs={4}>
              </Grid>
          })
        }
      </Grid>
    </Grid>
  )
}

export default Presentation
